import {
    CheckBadgeIcon,
    InboxArrowDownIcon,
    TruckIcon,
} from "@heroicons/react/24/outline";
import { OutcomeGoalMetric } from "@sp-crm/core";
import { activityCategoryIcons } from "components/tasks/activity-category-icons";
import React from "react";
import { GoalColumn } from "./goal-columns";

export type GoalColumnIcon = React.ComponentType<React.SVGProps<SVGSVGElement>>;

export const outcomeGoalMetricIcons: Record<OutcomeGoalMetric, GoalColumnIcon> = {
    referrals: InboxArrowDownIcon,
    careStarts: CheckBadgeIcon,
    movesCompleted: TruckIcon,
};

export const goalColumnIcon = (column: GoalColumn): GoalColumnIcon =>
    column.kind === "activity"
        ? activityCategoryIcons[column.category]
        : outcomeGoalMetricIcons[column.metric];
